import React, { useState, useContext } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import AppContext from '../../contexts/app-context';

import ApiServiceServerless from '../../xhr_libs';
import SmallerLoader from '../SmallerLoader';


export const PlugDownloadBill = (props) => {
  const { plug_url, organization_id, style, account_string, date_string } = props;

  const { showToast } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = () => {
    setIsLoading(true)
    ApiServiceServerless.get(
      `${plug_url}/private`,
      {
        authorization_id: organization_id,
      }
    ).then((res) => {
      const old_link = document.getElementById('bill-download-link');
      if (old_link) {
        old_link.remove();
      }
      const link = document.createElement('a');
      link.href = res.data;
      link.id = 'bill-download-link';
      link.target = '_blank';
      link.setAttribute('download', `Bill ${account_string} ${date_string}.pdf`);
      document.body.appendChild(link);
      link.click();
    })
      .catch(() => {
        showToast('danger', 'Error', "There was an issue downloading the requested bill. An attempt will be made to email a copy of the bill to you. If you do not receive it, please reach out to an administrator.")
      })
      .finally(() => {
        setIsLoading(false)
      })

  }

  return (
    <>
      {isLoading &&
        <SmallerLoader style={style} className='et-link' />
      }
      {!isLoading &&
        <FontAwesomeIcon
          style={style}
          icon={faDownload}
          onClick={() => handleDownload()}
          className='et-link'
          title='Download Bill'
        />}
    </>
  )
}